module.exports = __webpack_public_path__ + "img/sh.svg";